import { render, staticRenderFns } from "./LgFinderPageSolicitacaoManutencaoPatrimonial.vue?vue&type=template&id=7b5af91a"
import script from "./LgFinderPageSolicitacaoManutencaoPatrimonial.vue?vue&type=script&lang=js"
export * from "./LgFinderPageSolicitacaoManutencaoPatrimonial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports